
const Page_GetStarted = () => {

    return(
        <div>
            Download the app <a href="https://ionscreendatasaprod.blob.core.windows.net/public/com.kaimonos.IonScreenPlayer-Signed.apk" className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">here</a>
        </div>
    );
}

export default Page_GetStarted;